import styled from 'styled-components';
import theme from '../../styles/defaultTheme';
import Button from '../../components/Button';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 70vh;

    @media (max-width: 900px) {
        flex-wrap: wrap;

        * {
            text-align: center;
        }

        button {
            width: 100%;
            margin-bottom: 16px;
            color: ${(props) => props.theme.orangeLink};
        }

        img {
           width: 80% 
        }
    }
`;

export const Messages = styled.div`
    margin-left: 30px;
    font-size: ${theme.font.size16};

    @media (max-width: 900px) {
        margin: 0px 16px;
    }
`;

export const Title = styled.h1`
    font-weight: bold;
    margin-bottom: 16px;
    color: ${(props) => props.theme.black};
`;

export const Description = styled.p`
    margin-bottom: 32px;
    color: ${(props) => props.theme.black};
`;

export const StyledButton = styled(Button)`
    background-color: ${(props) => props.theme.orangeLink};
`;


